export const TEST = 'test'
export const LIVE = 'live'
